import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RegistryService} from "../../../../services/registry.service";
import {CartService} from "../../../../services/cart.service";
import {Product} from "../../../../models/product";
import {ProductDataSet} from "../../../../models/product-data-set";
import {ProductService} from "../../../../services/product.service";
import {ProductOptionsService} from "../product-options/product-options.service";
import {WishlistService} from "../../../../services/wishlist.service";
import {environment} from "../../../../../../environments/environment";
import {MatSnackBar} from '@angular/material/snack-bar';
import {GoogleAnalyticsService} from "../../../../services/google-analytics.service";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-product-information',
    templateUrl: './product-information.component.html',
    styleUrls: ['./product-information.component.css']
})
export class ProductInformationComponent implements OnInit, OnDestroy {
    @Input() product: Product;

    env = environment;
    hasSpecialPrice = false;
    wishlistitem_id = null;
    configurableProductOptions: Product[] = [];
    isAdding = false;
    qty = 1;
    tempQty = 0;
    qtyUpdatedEvent;
    wishList = null;
    // itemOptionSelectedEvent;
    current_currency;
    price;

    productUrl
    productTitle = 'test title';
    productDescription = 'test description';
    productImage = null

    isProductInWishlist = false;
    InWishlist = false;
    constructor(public registry: RegistryService,
                public cartService: CartService,
                private googleService: GoogleAnalyticsService,
                public productService: ProductService,
                public productOptionService: ProductOptionsService,
                public wishListService: WishlistService,
                private snackBar: MatSnackBar,
                private translate: TranslateService,
                public route: ActivatedRoute
    ) {


        this.current_currency = registry.current_currency;
        this.registry.CurrencyChangedEvent$.subscribe(currency => {

            this.current_currency = currency;
            this.recalcPrice();

        });

        this.qtyUpdatedEvent = cartService.QtyUpdatedEvent$.subscribe(qty => {
            this.qty = qty;
        });

        // this.itemOptionSelectedEvent = this.productOptionService.optionItemSelectedEvent.subscribe(product => {
        //     this.product = product;
        // })

        this.productOptionService.optionItemSelectedEvent.subscribe(product => {

            this.product = product;
            this.hasSpecialPrice = this.product.hasSpecialPrice();
            this.recalcPrice();

            this.googleService.productDetailsViewed(this.product.sku,this.product.name,this.product.price,"",this.current_currency);

        });



    }

    checkIfItemInFavorite(sku) {
        if (this.wishList == null) {
            return false;
        }
        this.isProductInWishlist = false;
        for (let i = 0; i < this.wishList?.items?.length; i++) {
            if (sku === this.wishList?.items[i]?.product.sku) {
              this.isProductInWishlist = true;
              this.wishlistitem_id = this.wishList?.items[i].id;

            }
        }
       // this.isProductInWishlist = false;
    }


    getSpecialPrice() {
        return this.product.getSpecialPrice() * this.registry.getExchangeRate();
    }



    ngOnInit(): void {

        this.price = this.product.price * this.registry.getExchangeRate();
        this.hasSpecialPrice = this.product.hasSpecialPrice();

        this.productUrl = this.route.url;
        this.productImage = '';
        this.getConfigurableProductOptions();

        if (this.registry.customer != undefined) {
            this.wishList = JSON.parse(localStorage.getItem('wishlist'));
            this.checkIfItemInFavorite(this.product.sku);
        }

        // console.log(  this.product.options[0].id);


        // this.productOptionService.optionItemSelectedEvent.subscribe(product => {
        //
        //     this.product = product;
        //
        // });

    }

    recalcPrice() {
        let rate = this.registry.getExchangeRate()
        this.price = this.product.price * rate;

    }

    getImageURL() {

        const image_url = this.product.getImage();
        return image_url;

    }

    ngOnDestroy(): void {
        this.qtyUpdatedEvent.unsubscribe();
    }

    addItemToWishlist(event) {

        event.preventDefault();
        this.wishListService.addWishlistItem(this.product.sku).subscribe(result => {

            this.openSuccessSnackBar(this.translate.instant('item_add_to_whishlist'), 'OK');
            this.wishListService.getCustomerWishlist().subscribe(result=>{

                this.wishList = result ;
                localStorage.setItem('wishlist',JSON.stringify(result));
                this.checkIfItemInFavorite(this.product.sku);
                this.googleService.eventEmitter("add_to_wishlist",'shop','cart','add_to_wishlist',this.product?.price);

                //  this.googleService.productAddedToWishlist(this.product.sku,this.product.name,this.product.price,"",this.current_currency);


            });

           // this.googleService.eventEmitter("add_to_wishlist", 'shop', 'cart', 'click', 10);

        });
    }

    deleteItemFromWishlist(event) {
        event.preventDefault();
        const obj = {
            'id': this.product.id,
            'product': this.product,
        };
        const index = this.wishList.items.findIndex(object => {
            return object.product.sku === obj.product.sku;
        });
        this.wishList.items.splice(index, 1);
        this.registry.wishList = this.wishList;
        this.wishListService.removeWishlistItem2(this.registry.customer.id,this.wishlistitem_id).subscribe(result => {

            this.googleService.eventEmitter('remove_from_wishlist', 'ecommerce', 'remove_from_wishlist', this.product.name + '-' + this.product.sku, this.product.price);

            this.wishListService.getCustomerWishlist().subscribe(result=>{

                this.wishList = result ;
                localStorage.setItem('wishlist',JSON.stringify(result));
                this.checkIfItemInFavorite(this.product.sku);
                this.googleService.eventEmitter("remove_from_wishlist",'shop','cart','remove_from_wishlist',this.product?.price);


            });

            this.openSuccessSnackBar(this.translate.instant('remove_item_from_whishlist'), 'OK');

        });
    }

    isInWishlist(){

        this.wishListService

    }

    addItemToCart() {

        //console.log(this.product.sku);

        this.isAdding = true;
        let cartId = localStorage.getItem('cartId');
        this.cartService.addItemToCart(this.registry.cart, this.product.sku, this.qty).subscribe(resp => {


                let ctype = localStorage.getItem('customer_type');

                if (ctype == 'guest') {
                    this.cartService.getGuestCart(this.cartService.cart.quoteId,this.registry.getWebsiteId()).subscribe(cart => {
                        cart.cartType = 'guest';
                        cart.quoteId = cartId;
                        this.registry.cart = cart;
                        this.cartService.cart = cart;
                        this.cartService.EmitCartUpdated(cart);
                        this.isAdding = false;
                        this.googleService.eventEmitter("add_to_cart", 'ecommerce', 'add_to_cart', this.product.name + "-" + this.product.sku, this.product.price);
                    });
                } else {
                    //user
                    this.cartService.getCustomerCart(this.registry.getWebsiteId()).subscribe(cart => {

                        cart.cartType = 'user';
                        cart.quoteId = cartId;
                        this.registry.cart = cart;
                        this.cartService.cart = cart;
                        this.cartService.EmitCartUpdated(cart);
                        this.isAdding = false;
                        this.googleService.eventEmitter("add_to_cart", 'ecommerce', 'add_to_cart', this.product.name + "-" + this.product.sku, this.product.price);

                    });
                }

            },
            error => {
                this.openSuccessSnackBar("There was an error adding item to cart", "OK");
                this.isAdding = false;

            }
        );

    }

    newValue(value) {
        this.qty = value;
        this.cartService.EmitQtyUpdated(this.qty);

    }

    getConfigurableProductOptions() {

        //console.log(this.item.getExtentionAttByKey('configurable_product_links'));
        if (this.product.extension_attributes.configurable_product_links) {
            let cs = this.product.extension_attributes.configurable_product_links.toString();
            let dataset = new ProductDataSet();
            dataset.pushParams('entity_id', cs, 'in');
            this.productService.ProductSearchAdv('entity_id', cs, 'in', 1,this.registry.getWebsiteId()).subscribe(result => {

                this.configurableProductOptions = result.items.map(item => Object.assign(new Product, item));

            //    console.log(result.items.map(item => Object.assign(new Product, item)));

            });
        }

    }

    // Snackbar that opens with success background
    openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
            horizontalPosition: "right",
            panelClass: ['primary-snackbar'],
        });
    }


}
